<template>
  <a-drawer
:maskClosable="false"
width="35%"
:label-col="4"
:wrapper-col="14"
:visible="open"
@close="onClose"
    :destroyOnClose="true">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <LoadingPop v-if="showLoading" ref="LoadingPop" @ok="showLoading = false" />
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="企业品牌" prop="tenantFirmId" v-if="userTentant.type !== 1">
        <a-select
show-search
:allowClear="true"
v-model="form.tenantFirmId"
placeholder="请选择"
          option-filter-prop="children"
:filter-option="filterOption">
          <a-select-option v-for="d in userList" :key="d.id">{{ d.name }}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="设备名称" prop="devName">
        <a-input v-model="form.devName" placeholder="请输入" :maxLength="50" />
      </a-form-model-item>
      <a-form-model-item label="设备编号" prop="devCode">
        <a-input v-model="form.devCode" placeholder="请输入" :maxLength="50" />
      </a-form-model-item>
      <a-form-model-item label="排序" prop="sort">
        <a-input v-model="form.sort" placeholder="请输入" :maxLength="20" oninput="value=value.replace(/[^\d]/g,'')" />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm"> 保存 </a-button>
          <a-button type="dashed" @click="cancel"> 取消 </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>
<script>
import { mapGetters } from 'vuex'

import { getObj, addObj, putObj } from '@/api/pressure/device'
export default {
  name: 'CreateForm',
  props: {
    statusOptions: {
      type: Array,
      required: true,
    },
    userList: {
      type: Array,
      required: true,
    },
  },
  components: {},
  data() {
    return {
      submitLoading: false,
      showLoading: false,
      data: [],
      formTitle: '',
      // 表单参数
      form: {
        id: undefined,
        devCode: undefined,
        devName: undefined,
        tenantFirmId: undefined,
        remark: undefined,
        sort: 99,
      },
      open: false,
      hour: [],
      hours: [],
      minute: [],
      minutes: [],
      rules: {
        devName: [{ required: true, message: '请输入的设备名称', trigger: 'blur' }],
        devCode: [{ required: true, message: '请输入设备编号', trigger: 'blur' }],
        sort: [{ required: true, message: '请输入排序', trigger: 'blur' }],
        tenantFirmId: [{ required: true, message: '请选择企业品牌', trigger: 'blur' }],
      },
    }
  },
  filters: {},
  created() {
    console.log('statusOptions 显示隐藏', this.statusOptions)
  },
  computed: {
    ...mapGetters(['userTentant', 'infoUser']),
  },
  watch: {},
  methods: {
    onClose() {
      const that = this
      this.$confirm({
        title: '是否确认关闭清空数据',
        onOk() {
          console.log(that.open, 'openopen')
          that.open = false
        },
        onCancel() { },
      })
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    // 取消按钮
    cancel() {
      this.onClose()
    },
    // 表单重置
    reset() {
      this.form = {
        id: undefined,
        devCode: undefined,
        devName: undefined,
        tenantFirmId: undefined,
        remark: undefined,
        sort: 99,
      }
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.reset()
      this.open = true
      this.formTitle = '添加设备'
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      const postId = row ? row.id : ids
      getObj(postId).then((response) => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改设备'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      console.log(this.form, '对对对对对对')

      this.$refs.form.validate((valid, object) => {
        if (valid) {
          this.submitLoading = true
          this.showLoading = true
          this.$nextTick(() => {
            this.$refs.LoadingPop.init(1)
          })
          if (this.form.id !== undefined) {
            putObj(this.form)
              .then((response) => {
                this.$message.success('修改成功', 3)
                this.open = false
                this.$emit('ok')
              })
              .finally(() => {
                this.submitLoading = false
                this.showLoading = false

              })
          } else {
            addObj(this.form)
              .then((response) => {
                this.$message.success('新增成功', 3)
                this.open = false
                this.$emit('ok')
              })
              .finally(() => {
                this.submitLoading = false
                this.showLoading = false

              })
          }
        } else {
          const messages = Object.values(object).flatMap((errorArray) => errorArray.map((item) => item.message))
          this.showLoading = true
          this.$nextTick(() => {
            this.$refs.LoadingPop.init(2, messages)
          })
          return false
        }
      })
    },
  },
}
</script>
